import gql from "graphql-tag"
import {
  BillingPlanFieldsFragmentDoc,
  CreditCardFieldsFragmentDoc,
} from "@modules/organization/fragments.generated"

// type SubscriptionCreateInput { token: ID!, planId:
// UUID!, organizationID: UUID!, companyName: String }
export const SUBSCRIBE_TO_PLAN = gql`
  mutation subscribeToPlan($input: SubscriptionCreateInput!) {
    subscribeToPlan(input: $input) {
      token
      errors {
        message
      }
      subscription {
        id
        creditCard {
          ...creditCardFields
        }
        plan {
          ...billingPlanFields
        }
        nextBillingDate
      }
    }
  }
  ${BillingPlanFieldsFragmentDoc}
  ${CreditCardFieldsFragmentDoc}
`

export const UPDATE_PAYMENT_INFO = gql`
  mutation updatePaymentInfo(
    $organizationId: UUID!
    $token: String!
    $customerName: String!
    $billingEmail: String
  ) {
    updatePaymentInformation(
      organizationId: $organizationId
      token: $token
      customerName: $customerName
      billingEmail: $billingEmail
    ) {
      errors {
        errorType
        code
        message
        declineCode
      }
      creditCard {
        ...creditCardFields
      }
    }
  }

  ${CreditCardFieldsFragmentDoc}
`
